// @internal
import styled from 'styled-components';
import { StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';

type StyledSideNavGroupProps = Pick<StyledSideNavProps, 'isClosed'> &
  React.HTMLAttributes<HTMLLIElement> & { highlighted?: boolean };

export const StyledSideNavGroup = styled.li<StyledSideNavGroupProps>`
  background-color: ${({ highlighted }) =>
    highlighted ? sidenavTokens.GroupContainerBackgroundColorBaseHighlighted : 'transparent'};
  scroll-margin-block-start: ${({ isClosed }) => (isClosed ? 0 : sidenavTokens.StickyContainerTopHeightBaseDefault)};
  transition: ${sidenavTokens.GroupContainerTransitionBaseDefault};
`;
